{
	"language": {
		"select": "Pilih bahasa",
		"sectionTitle": "Bahasa",
		"changeSuccess": "Bahasa berjaya ditukar"
	},
	"assistant": {
		"composer": {
			"placeholder": "Tanya {{assistantName}}",
			"disclaimer": "{{assistantName}} boleh membuat kesilapan. Semak maklumat penting."
		},
		"greeting": {
			"initialMessage": "👋 Hai, saya pembantu pembelajaran **{{assistantName}}**, dan saya di sini untuk membantu anda membuat persediaan yang lebih baik untuk **{{context}}!** Mari kita teliti secara khusus item yang anda jawab tentang **{{topic}}.**",
			"starter": "Hai, saya **{{assistantName}}**. Bagaimana saya boleh membantu?"
		},
		"chips": {
			"askYourOwn": "Tanya soalan anda sendiri",
			"askFollowUp": "Tanya soalan susulan"
		},
		"emptyState": {
			"title": "{{assistantName}} ialah pembantu pembelajaran AI anda",
			"contextSubtitle": "Tanya apa-apa sahaja tentang {{context}}",
			"activateSubtitle": "{{assistantName}} akan diaktifkan selepas anda menjawab soalan"
		}
	},
	"dashboard": {
		"header": {
			"quickStudy": "Belajar pantas",
			"examInfo": {
				"subtitle": {
					"setExamDate": "Tetapkan tarikh peperiksaan",
					"examDateWithValue": "Tarikh peperiksaan: <date>{{date}}</date>"
				}
			}
		},
		"reviewPrompt": {
			"buttons": {
				"couldBeBetter": "Boleh diperbaiki",
				"itsAwesome": "Ia hebat"
			},
			"title": "Anda semakin rancak!",
			"body": "Kami teruja melihat komitmen anda dalam pembelajaran! Bagaimana pengalaman anda dengan aplikasi ini setakat ini? Sudikah anda berkongsi pendapat melalui ulasan?",
			"cta": "Mungkin nanti"
		},
		"actions": {
			"studyWeak": "Fokus pada bidang lemah",
			"viewProgress": "Lihat kemajuan anda",
			"seeRank": "Semak kedudukan anda",
			"seeRankings": "Lihat papan pendahulu",
			"unlock": "Buka kandungan premium",
			"unlockTooltip": "Dapatkan akses kepada ciri eksklusif dan bahan pembelajaran lanjutan dengan membuka kandungan premium",
			"startCustomSession": "Cipta sesi tersuai",
			"startCustomSessionTooltip": "Mulakan sesi pembelajaran tersuai untuk menumpukan pada bidang tertentu dalam pembelajaran anda",
			"takeDiagnostic": "Ambil diagnostik",
			"takeDiagnosticTooltip": "Ambil diagnostik untuk menilai tahap semasa anda dan menyesuaikan pelan pembelajaran anda",
			"viewDiagnostic": "Lihat keputusan diagnostik",
			"viewDiagnosticTooltip": "Lihat keputusan diagnostik anda untuk mengetahui kekuatan dan bidang yang perlu diperbaiki",
			"viewPodcasts": "Dengar podcast",
			"viewPodcastsTooltip": "Akses podcast pendidikan untuk memperkaya pengalaman pembelajaran anda",
			"upgradeToPremium": "Naik taraf ke premium",
			"upgradeToPremiumTooltip": "Naik taraf ke premium untuk mengakses semua kandungan dan ciri",
			"extendAccess": "Lanjutkan akses",
			"extendAccessTooltip": "Lanjutkan akses anda kepada kandungan dan ciri premium",
			"setExamDate": "Tetapkan tarikh peperiksaan",
			"setExamDateTooltip": "Tetapkan tarikh peperiksaan anda untuk menjejaki kemajuan dan bersedia untuk peperiksaan"
		},
		"exam": {
			"daysAgo_one": "{{count}} hari lalu",
			"daysAgo_other": "{{count}} hari lalu",
			"untilExam_one": "{{count}} hari lagi sebelum peperiksaan",
			"untilExam_other": "{{count}} hari lagi sebelum peperiksaan",
			"isToday": "Peperiksaan adalah hari ini!"
		},
		"stats": {
			"mastery": "Penguasaan",
			"completed_one": "Item dijawab",
			"completed_other": "Item dijawab",
			"completedValue": "{{count}}",
			"xpEarned": "XP diperoleh",
			"xpEarnedValue": "{{value}}",
			"accuracy": "Ketepatan",
			"accuracyValue": "{{value}}%",
			"skillLevelTooltip": "Anggaran kecekapan {{skill, lowercase}} anda ialah {{level, lowercase}}",
			"itemsAnsweredTooltip": "Jumlah item yang telah anda jawab setakat ini",
			"responsesAnsweredTooltip": "Jumlah keseluruhan jawapan yang telah anda hantar setakat ini",
			"examDateTooltip": "Peperiksaan anda pada {{date}}",
			"skillCta": {
				"diagnostic": "Diagnostik",
				"practice": "Berlatih"
			}
		},
		"menu": {
			"settings": "Tetapan",
			"profile": "Profil"
		},
		"diagnostics": {
			"title": "Diagnostik",
			"free": "Percuma",
			"duration": "{{count}} {{item}} • {{minutes}} minit",
			"completed": "{{count}} {{item}} selesai",
			"start": "Mula",
			"viewReport": "Lihat laporan",
			"resume": "Sambung"
		},
		"practiceTests": {
			"title": "Ujian latihan",
			"sectionalTestsTitle": "Ujian seksyen",
			"diagnosticAssessmentsTitle": "Pentaksiran diagnostik",
			"premiumChipTooltip": "Ujian latihan premium sepenuh panjang untuk peperiksaan {{examName}}",
			"freeChipTooltip": "{{label}} untuk peperiksaan {{examName}}",
			"freeChipTooltipDefault": "Pentaksiran diagnostik percuma untuk peperiksaan {{examName}}",
			"completedDescription_one": "{{count}} item • {{date}}",
			"completedDescription_other": "{{count}} item • {{date}}",
			"activeDescription_one": "{{attempted}}/{{count}} item • {{timeRemaining}} lagi",
			"activeDescription_other": "{{attempted}}/{{count}} item • {{timeRemaining}} lagi",
			"activeDescriptionWithDates_one": "{{attempted}}/{{count}} item • {{timeRemaining}} lagi • Bermula pada: {{startedOn}} • Tamat pada: {{endsOn}}",
			"activeDescriptionWithDates_other": "{{attempted}}/{{count}} item • {{timeRemaining}} lagi • Bermula pada: {{startedOn}} • Tamat pada: {{endsOn}}",
			"notStartedDescription_one": "{{count}} item • {{duration}}",
			"notStartedDescription_other": "{{count}} item • {{duration}}",
			"notStartedDescriptionWithEnd_one": "{{count}} item • {{duration}} • Tamat pada: {{endsOn}}",
			"notStartedDescriptionWithEnd_other": "{{count}} item • {{duration}} • Tamat pada: {{endsOn}}",
			"viewResultsCta": "Lihat keputusan",
			"startCta": "Mula",
			"chips": {
				"items_one": "{{count}} item",
				"items_other": "{{count}} item",
				"progress_one": "{{attempted}}/{{count}} item",
				"progress_other": "{{attempted}}/{{count}} item",
				"timeRemaining": "{{time}} lagi",
				"startedOn": "Bermula pada: {{date}}",
				"endsOn": "Tamat pada: {{date}}",
				"timeLeft": "{{time}} lagi"
			},
			"status": {
				"notStarted": {
					"label": "Belum bermula",
					"section": "Ujian Latihan Sepenuh Panjang"
				},
				"inProgress": {
					"label": "Sedang berjalan",
					"section": "Sedang berjalan"
				},
				"completed": {
					"label": "Selesai",
					"section": "Selesai"
				},
				"legacyReports": {
					"label": "Laporan lama",
					"section": "Laporan lama"
				},
				"migratedReports": {
					"label": "Laporan dipindahkan",
					"section": "Laporan dipindahkan"
				}
			}
		},
		"skills": {
			"title": "Kemahiran",
			"unlockSubtitle": "Buka premium untuk berlatih",
			"startCta": "Berlatih",
			"freeItemsIncludedChip": "Item percuma disertakan",
			"freeItemsAnsweredSubtitle_one": "{{answered, number}} daripada {{count, number}} item percuma dijawab",
			"freeItemsAnsweredSubtitle_other": "{{answered, number}} daripada {{count, number}} item percuma dijawab",
			"progressCards": {
				"questionTypesTitle": "Prestasi mengikut jenis soalan",
				"questionTypesSubtitle": "Pencapaian anda merentas jenis soalan {{skill}}",
				"proficiencyTitle": "Prestasi mengikut kecekapan",
				"proficiencySubtitle": "Kemajuan anda merentas tahap {{skill}}",
				"questionTypeCardSubtitle": "Kemajuan mengikut tahap kecekapan",
				"bySkillTitle": "Prestasi mengikut kemahiran",
				"bySkillSubtitle": "Kemajuan keseluruhan merentas kemahiran",
				"needsImprovementTitle": "Perlu penambahbaikan",
				"needsImprovementSubtitle": "Kemahiran yang perlu difokuskan seterusnya",
				"skillPerformanceTitle": "Prestasi {{skill}}",
				"skillPerformanceSubtitle": "Kemajuan mengikut jenis soalan dan kecekapan",
				"skillLevelSubtitle": "Kemajuan anda pada tahap kemahiran ini",
				"skillsPerformanceTitle": "Prestasi Kemahiran",
				"performanceByItemDifficulty": "Prestasi mengikut kecekapan item",
				"performanceByItemDifficultyCaption_one": "Menunjukkan ketepatan anda mengikut tahap kecekapan, berdasarkan {{count}} item yang dijawab",
				"performanceByItemDifficultyCaption_other": "Menunjukkan ketepatan anda mengikut tahap kecekapan, berdasarkan {{count}} item yang dijawab",
				"questionTypePartSubtitle": "{{skill}} · Bahagian {{part}}",
				"activityGoalTitle": "Kemajuan Aktiviti & Matlamat",
				"recentActivityTitle": "Aktiviti Terkini",
				"goalProgressTitle": "Kemajuan Matlamat",
				"goalProgressSubtitle": "Markah keseluruhan · 7 minggu lepas",
				"goalProgressInsight": "Anda menunjukkan peningkatan yang mantap. Anda 14 mata di bawah sasaran dan berkemungkinan mencapai matlamat dalam kira-kira 3 minggu.",
				"goalProgressActualLabel": "Markah anda",
				"goalProgressTargetLabel": "Sasaran",
				"goalProgressTimeAxisLabel": "Masa",
				"goalProgressScoreAxisLabel": "Kemajuan Keseluruhan",
				"statusTitle": "Status Anda",
				"diagnosticsTitle": "Diagnostik",
				"diagnosticsReviewCta": "Semak",
				"strengthsFocusTitle": "Kekuatan & Bidang Fokus",
				"strengthsFocusSubtitle": "Bidang terkuat anda dan jenis soalan yang memerlukan lebih latihan",
				"strengthsLabel": "Kekuatan",
				"focusAreasLabel": "Bidang Fokus",
				"recommendedNextStepLabel": "Langkah Seterusnya Yang Disyorkan",
				"recommendedNextStepCta": "Mula",
				"practiceTestsViewMore": "Lihat semua {{count}} ujian"
			},
			"proficiencySection": "Berlatih mengikut tahap kecekapan"
		},
		"recommendedTasks": {
			"sectionTitle": "Disyorkan untuk anda",
			"startSessionAction": "Latih",
			"resumeAction": "Sambung",
			"reviewResultsAction": "Semak keputusan",
			"startTestAction": "Mula ujian",
			"activeTestBody": "Selesaikan pentaksiran anda yang sedang berjalan",
			"completedTestBody": "Semak prestasi dan jawapan anda",
			"diagnosticBody": "Ambil {{label}} untuk membiasakan diri dengan format peperiksaan",
			"diagnosticDefaultLabel": "diagnostik percuma",
			"practiceTestBody": "Nilai kesediaan peperiksaan anda dengan ujian bermasa.",
			"sectionalTestBody": "Ambil ujian fokus untuk melatih kemahiran {{skills}} anda.",
			"weakSkillTitle": "Bina {{skill}} anda",
			"weakSkillBody": "Latihan {{questionType}}, diberi pemberat pada yang belum anda kuasai.",
			"strongSkillTitle": "Kekalkan {{skill}} anda",
			"strongSkillBody": "Anda kukuh di sini. Set {{questionType}} singkat mengekalkannya.",
			"mixedSkillTitle": "Lengkapkan {{skill}} anda",
			"mixedSkillBody": "Set campuran merentas {{questionTypes}}, diberi pemberat pada yang anda terlepas.",
			"higherDifficultySkillTitle": "Naik ke {{proficiency}}",
			"higherDifficultySkillBody": "Anda sudah menguasai {{questionType}} pada tahap ini. Ini selangkah lebih sukar.",
			"itemsChip_one": "{{count}} item",
			"itemsChip_other": "{{count}} item",
			"timeRemainingChip": "{{minutes}} minit lagi",
			"timeRemainingChipCompact": "{{minutes}} minit"
		},
		"itemTypes": {
			"answeredLabel_one": "Item dijawab",
			"answeredLabel_other": "Item dijawab",
			"answeredAll": "Semua",
			"answeredPartial": "{{answered}} daripada {{total}}",
			"cardSubtitleResponses_one": "{{count}} jawapan",
			"cardSubtitleResponses_other": "{{count}} jawapan",
			"responsesLabel_one": "Jawapan",
			"responsesLabel_other": "Jawapan",
			"cardSubtitleComplete": "Semua item telah dijawab",
			"cardSubtitlePartial": "{{attempted}} daripada {{total}} item dijawab",
			"detail": {
				"skillLabel": "Kemahiran",
				"estimatedLevelLabel": "Anggaran tahap"
			}
		},
		"tagSections": {
			"summary": "{{tagCount, number}} {{label, lowercase}} • $t(common.itemCount, {\"count\": {{itemCount}} })",
			"summaryWithoutItemCount": "{{tagCount, number}} {{label, lowercase}}",
			"responseCount_one": "{{count, number}} jawapan",
			"responseCount_other": "{{count, number}} jawapan"
		},
		"studyPack": {
			"freeContentBannerTitle_one": "{{count, number}} item latihan percuma disertakan",
			"freeContentBannerTitle_other": "{{count, number}} item latihan percuma disertakan",
			"freeContentBannerBody": "Berlatih item {{skills}} pada bila-bila masa. Naik taraf untuk membuka Pakej Pembelajaran lengkap.",
			"freeContentBannerCta": "Mulakan latihan percuma"
		}
	},
	"appbar": {
		"leaderboard": {
			"description": "Lihat kedudukan anda berbanding yang lain"
		},
		"home": {
			"title": "Utama"
		},
		"podcasts": {
			"description": "Dengar podcast ortopedik yang dikendalikan pakar."
		},
		"more": {
			"title": "Tetapan Lain"
		}
	},
	"emptyState": {
		"progress": {
			"title": "Tiada kemajuan pembelajaran",
			"subtitle": "Kemajuan anda akan dipaparkan di sini semasa anda belajar",
			"cta": "Belajar sekarang"
		}
	},
	"errors": {
		"sessionCreation": {
			"title": "Ralat",
			"body": "Sesi gagal dicipta, sila cuba lagi"
		}
	},
	"mastery": {
		"labels": {
			"advanced": "Lanjutan",
			"highIntermediate": "Pertengahan",
			"intermediate": "Pertengahan",
			"basic": "Asas",
			"none": "Belum dijawab",
			"high": "Dikuasai",
			"medium": "Hampir dikuasai",
			"low": "Perlu diperbaiki"
		}
	},
	"leaderboard": {
		"you": "Ini anda",
		"periods": {
			"all_time": "Sepanjang masa",
			"month": "Bulan ini",
			"week": "Minggu ini"
		},
		"scope": {
			"global": "Global",
			"friends": "Rakan"
		},
		"friends": {
			"soon": "AKAN DATANG",
			"comingSoonTitle": "Papan pendahulu rakan",
			"comingSoonBadge": "Akan datang",
			"comingSoonDescription": "Jejaki kemajuan anda berbanding rakan dan lihat siapa yang berada di puncak kelas."
		},
		"error": {
			"title": "Ralat sambungan",
			"description": "Papan pendahulu tidak dapat dimuatkan. Semak sambungan anda dan cuba lagi.",
			"tryAgain": "Cuba lagi"
		},
		"empty": {
			"title": "Belum ada pendahulu",
			"description": "Kedudukan dikemas kini apabila lebih ramai belajar. Jadilah yang pertama memperoleh XP dan rebut tempat teratas!",
			"startLearning": "Belajar sekarang"
		},
		"topPerformers": "Prestasi terbaik",
		"yourPosition": "Kedudukan anda",
		"rankings": "Kedudukan",
		"rankingsRange": "Kedudukan • #{{startRank}}–{{endRank}}",
		"unranked": {
			"title": "Peroleh XP untuk menyertai kedudukan!",
			"description": "Mulakan sesi pembelajaran untuk memperoleh mata pertama anda dan menyertai papan pendahulu.",
			"cta": "Mulakan sesi pertama anda"
		},
		"xpAmount": "<num>{{value}}</num> <unit>XP</unit>",
		"youBadge": "Anda",
		"podium": {
			"first": "ke-1",
			"second": "ke-2",
			"third": "ke-3"
		},
		"footer": {
			"gapHintToPass": "<num>+{{value}}</num><unit> XP</unit> <rest>untuk memintas #{{rank}}</rest>",
			"gapHintFromPodium": "<num>{{value}}</num><unit> XP</unit> <rest>daripada podium</rest>"
		}
	},
	"lessons": {
		"explore": {
			"title": "Pelajaran",
			"searchPlaceholder": "Cari pelajaran",
			"count_one": "{{count}} Pelajaran",
			"count_other": "{{count}} Pelajaran",
			"sortModalTitle": "Isih pelajaran",
			"filterModalTitle": "Tapis mengikut topik",
			"sort": {
				"popularity": "Populariti",
				"popularityShort": "Popular",
				"topic": "Topik",
				"difficulty": "Kesukaran",
				"recent": "Baru dikemas kini",
				"recentShort": "Dikemas kini",
				"completed": "Selesai"
			},
			"chips": {
				"all": "Semua",
				"recent": "Baru dikemas kini",
				"completed": "Selesai",
				"premium": "Premium",
				"topics": "Topik",
				"topicsCount_one": "{{count}} topik",
				"topicsCount_other": "{{count}} topik"
			},
			"chipTooltips": {
				"all": "Tunjukkan semua pelajaran.",
				"recent": "Tunjukkan pelajaran yang baru dikemas kini.",
				"completed": "Tunjukkan pelajaran yang selesai.",
				"premium": "Tunjukkan pelajaran premium.",
				"topics": "Tapis pelajaran mengikut topik."
			},
			"filterNames": {
				"premium": "premium",
				"completed": "selesai",
				"topics": "topik"
			},
			"empty": {
				"searchTitle_one": "{{count}} pelajaran disembunyikan oleh carian",
				"searchTitle_other": "{{count}} pelajaran disembunyikan oleh carian",
				"searchSubtitle": "Cuba kata kunci lain atau kosongkan carian anda",
				"searchCta": "Kosongkan carian",
				"filtersTitle_one": "{{count}} pelajaran disembunyikan oleh penapis",
				"filtersTitle_other": "{{count}} pelajaran disembunyikan oleh penapis",
				"filtersSubtitle_one": "Alih keluar penapis {{filters}} untuk melihat lebih banyak",
				"filtersSubtitle_other": "Alih keluar penapis {{filters}} untuk melihat lebih banyak",
				"filtersCta": "Kosongkan semua penapis",
				"noneTitle": "Tiada pelajaran dijumpai",
				"noneSubtitle": "Cuba alih keluar penapis atau mulakan carian baharu",
				"noneCta": "Tetapkan semula semua"
			}
		},
		"home": {
			"settings": {
				"a11yLabel": "Buka tetapan"
			},
			"continueLearning": {
				"title": "Teruskan pembelajaran"
			},
			"suggested": {
				"title": "Dicadangkan untuk anda"
			},
			"completed": {
				"title": "Selesai"
			},
			"all": {
				"title": "Semua pelajaran"
			},
			"emptyState": {
				"title": "Tiada pelajaran lagi",
				"subtitle": "Kembali semula nanti untuk pelajaran baharu."
			},
			"card": {
				"resumeCta": "Sambung semula",
				"progress": "{{value}}% selesai",
				"timeLeft_one": "{{count}} minit lagi",
				"timeLeft_other": "{{count}} minit lagi",
				"duration_one": "{{count}} minit",
				"duration_other": "{{count}} minit"
			}
		},
		"overview": {
			"header": {
				"title": "Gambaran keseluruhan"
			},
			"startCta": "Mula belajar",
			"objectives": {
				"title": "Objektif pembelajaran"
			}
		},
		"detail": {
			"takeQuizCta": "Jawab kuiz",
			"progress": {
				"label": "Kemajuan modul"
			},
			"activities": {
				"title": "Aktiviti",
				"completedCount": "{{completed}} daripada {{total}} selesai"
			},
			"artifact": {
				"completed": "Selesai",
				"locked": "Berkunci"
			}
		},
		"stats": {
			"insights": {
				"title": "Maklumat kemajuan"
			},
			"overallProgress": {
				"title": "Kemajuan keseluruhan",
				"completedCount_one": "{{completed}} daripada {{count}} item selesai",
				"completedCount_other": "{{completed}} daripada {{count}} item selesai"
			},
			"milestones": {
				"title": "Pencapaian modul"
			}
		},
		"studyGuide": {
			"sectionBadge": {
				"label": "Bahagian {{number}} daripada {{total}}"
			},
			"upNext": {
				"title": "Seterusnya"
			}
		}
	},
	"sessionConfig": {
		"title": "Sesi pembelajaran tersuai",
		"diagnostic": "Diagnostik",
		"skill": "Kemahiran",
		"Proficiency": "Kecekapan",
		"Question Type": "Jenis soalan",
		"mastery": "Penguasaan",
		"sessionLength": "Tempoh sesi",
		"itemsChip_one": "{{count}} item",
		"itemsChip_other": "{{count}} item",
		"durationEstimate": "{{minutes}} min",
		"durationRange": "{{min}}–{{max}} min",
		"noItemsTooltip": "Tiada item yang sepadan dengan penapis semasa",
		"setCount": "{{count}} {{type}}",
		"dismiss": "Ok",
		"status": {
			"notAnswered": "Belum dijawab",
			"needsWork": "Perlu diperbaiki"
		},
		"itemCount": "Anda akan melengkapkan {{count}} item merentas {{topics}}",
		"start": "Mulakan sesi",
		"configuringSession": "Mengkonfigurasi sesi",
		"fetchingContent": "Mendapatkan kandungan",
		"preparingMaterials": "Menyediakan bahan",
		"almostThere": "Hampir siap",
		"startingSession": "Memulakan sesi",
		"playIcon": "play-outline",
		"infoText": "Anda akan melengkapkan **{{numItems}}** {{itemCount}}. Ini mengambil masa kira-kira **{{timeString}}**.",
		"customSummary": {
			"message": "Pelajari $t(sessionConfig.customSummary.itemCount, {\"count\": {{count}}}) daripada {{topics}}.",
			"messageWithMastery": "Pelajari $t(sessionConfig.customSummary.itemCount, {\"count\": {{count}}}) daripada {{topics}}, dengan tumpuan pada $t(sessionConfig.customSummary.masteryLevelCount, {\"count\": {{masteryCount}}}) {{masteryLevels}}.",
			"messageAllMasteryLevels": "Pelajari $t(sessionConfig.customSummary.itemCount, {\"count\": {{count}}}) daripada {{topics}} merentas semua tahap penguasaan.",
			"itemCount_one": "{{count}} item",
			"itemCount_other": "{{count}} item",
			"masteryLevelCount_one": "tahap penguasaan",
			"masteryLevelCount_other": "tahap penguasaan",
			"allTopics": "semua {{count}} topik",
			"more": "{{count}} lagi",
			"quotedMasteryLevel": "“{{masteryLevel}}”"
		},
		"quickStudy": {
			"title": "Belajar Pantas",
			"recommended": "Disyorkan",
			"custom": "Tersuai",
			"selectHelper": "Ketik sesi untuk memilihnya, kemudian mulakan apabila anda bersedia.",
			"emptyRecommended": "Tiada sesi yang disyorkan tersedia buat masa ini.",
			"summary": "Pelajari {{count}} item daripada {{skill}}. Anggaran {{minutes}} minit.",
			"summary_questionType": "Pelajari {{count}} item daripada {{skill}}, {{questionType}}. Anggaran {{minutes}} minit.",
			"duration": "{{minutes}} minit",
			"durationSelector": {
				"title": "Tempoh"
			},
			"levelSessions": {
				"rapidRecall": "Imbas kembali pantas",
				"purposefulPractice": "Latihan berfokus",
				"focusFlow": "Aliran tumpuan",
				"itemsLabel": "Item {{level}}",
				"itemsLabelGeneric": "item",
				"summaries": {
					"rapidRecall": "Dapatkan pendedahan pantas kepada {{count}} item {{level}} yang belum anda jawab untuk meluaskan liputan secara berterusan. Anggaran {{minutes}} minit.",
					"purposefulPractice": "Selesaikan set seimbang {{count}} item {{level}}, bermula dengan bahan yang paling memerlukan perhatian. Anggaran {{minutes}} minit.",
					"focusFlow": "Kukuhkan kelemahan anda dengan {{count}} item {{level}} yang anda jawab dengan penguasaan rendah atau sederhana. Anggaran {{minutes}} minit."
				},
				"summariesGeneric": {
					"rapidRecall": "Dapatkan pendedahan pantas kepada {{count}} item yang belum anda jawab untuk meluaskan liputan secara berterusan. Anggaran {{minutes}} minit.",
					"purposefulPractice": "Selesaikan set seimbang {{count}} item, bermula dengan bahan yang paling memerlukan perhatian. Anggaran {{minutes}} minit.",
					"focusFlow": "Kukuhkan kelemahan anda dengan {{count}} item yang anda jawab dengan penguasaan rendah atau sederhana. Anggaran {{minutes}} minit."
				}
			},
			"lockedOptionsBanner": "Unlock {{names}} with Premium",
			"lockedOptionsBannerOverflow": "Unlock {{names}} and {{count}} more with Premium"
		}
	},
	"skillDetail": {
		"diagnosticInsight": "Untuk memperibadikan pengalaman anda, mulakan dengan kuiz diagnostik. Hasil diagnostik anda akan digunakan untuk membina pelan belajar anda."
	},
	"premium": {
		"chip": "Premium",
		"upgrade": "Naik taraf ke premium",
		"unlockTitle": "Buka pengalaman {{productName}} anda sepenuhnya",
		"unlockDescription": "Buka latihan peribadi yang direka berdasarkan baki masa belajar anda.",
		"readyTitle": "Bersedia untuk peperiksaan anda pada {{date}}",
		"tip": "Fokus peribadi anda: premium mengenal pasti perkara yang perlu dilatih seterusnya dan menyesuaikan pelan belajar anda apabila anda semakin maju."
	},
	"purchase": {
		"success": {
			"headerTitle": "Terima kasih atas pembelian anda!",
			"accessGranted": "Akses kepada {{name}} anda telah berjaya diberikan",
			"studyPack": "Pakej Pembelajaran",
			"practiceTest": "Ujian Latihan",
			"combo": "Pakej Gabungan",
			"documentTitle": "Pembelian",
			"summary_one": "Tahniah! **Produk** di bawah telah dibuka pada akaun anda. Selepas menekan {{action}}, konteks aplikasi anda akan ditukar untuk mencerminkan peperiksaan: **{{examName}}**. Anda boleh mengubahnya pada bila-bila masa dalam tetapan akaun jika anda mahu belajar untuk peperiksaan lain atau membeli produk lain.",
			"summary_other": "Tahniah! **{{count}} produk** di bawah telah dibuka pada akaun anda. Selepas menekan {{action}}, konteks aplikasi anda akan ditukar untuk mencerminkan peperiksaan: **{{examName}}**. Anda boleh mengubahnya pada bila-bila masa dalam tetapan akaun jika anda mahu belajar untuk peperiksaan lain atau membeli produk lain.",
			"unlockedDuration": "Tahniah! Anda telah membuka akses **{{duration}}** kepada **{{name}}**. Akses ini tamat pada **{{expiry}}**.",
			"storeNote": "Nota: Pakej Pembelajaran hanya boleh diakses melalui aplikasi mudah alih kami. Sila muat turun aplikasi yang sesuai untuk peranti anda.",
			"actions": {
				"goToHome": "Pergi ke laman utama",
				"startDiagnostic": "Mulakan {{label}}",
				"takeDiagnostic": "Ambil {{label}}",
				"takeFreeDiagnostic": "Ambil diagnostik percuma",
				"diagnosticLabel": "diagnostik"
			}
		},
		"checkout": {
			"headerTitle": "Lengkapkan Pembelian Anda"
		},
		"paywall": {
			"studyPackDialogTitle": "Naik taraf pelan pembelajaran anda",
			"defaultDialogTitle": "Naik taraf pelan pembelajaran anda",
			"practiceTestDialogTitle": "Buka ujian latihan",
			"restorePurchaseDialogTitle": "Sudah membeli?",
			"restorePurchaseDialogSubheadingWeb": "Jika tidak, cuba ini:",
			"restorePurchaseDialogBody": "Jika anda sudah membeli produk ini tetapi ia masih berkunci, sila cuba yang berikut:\n\n1. Pastikan anda log masuk ke akaun yang betul\n2. Pastikan produk yang betul dipilih\n3. Pastikan langganan anda belum tamat tempoh\n4. Pastikan anda telah mengaktifkan langganan (semak e-mel sampah anda)\n5. Jika anda mempunyai kod akses, [kod akses]({{baseUrl}}/redeem)\n\nJika tiada yang berkenaan, sila **klik di sini**",
			"restorePurchaseDialogBodyWeb": "1. Pastikan anda log masuk dengan e-mel yang betul\n2. Pastikan **[peperiksaan yang dipilih](/account/settings)** betul\n3. Pastikan langganan anda belum tamat tempoh\n\nJika tiada yang berkenaan, sila **hubungi sokongan**",
			"accesDuration": {
				"yearPlan": "Pelan **{{duration}}** memberikan akses lanjutan, memberi anda fleksibiliti maksimum untuk belajar mengikut rentak sendiri dan bersedia sepenuhnya untuk peperiksaan anda.",
				"moreTime": "Jika anda rasa memerlukan lebih masa untuk belajar, anda boleh mempertimbangkan pelan **{{duration}}**.",
				"otherPlan": "Pelan **{{duration}}** memberi anda akses sehingga **{{expiryText}}**, iaitu masa yang mencukupi untuk belajar. {{moreTime}}"
			},
			"actions": {
				"upgrade": "Naik taraf",
				"unlock": "Buka dengan harga {{price}}",
				"subscribe": "Langgan dengan harga {{price}}",
				"extendAccess": "Lanjutkan akses",
				"accessHere": "Akses di sini",
				"redeemAccessCode": "Ada kod akses?",
				"restorePurchase": "Sudah membeli?",
				"restorePurchaseWeb": "Sudah membeli atau ada kod akses?"
			},
			"subscriptionSummary": {
				"yearly": "Langganan tahunan • Pembaharuan automatik • Batal bila-bila masa",
				"monthly": "Langganan bulanan • Pembaharuan automatik • Batal bila-bila masa",
				"weekly": "Langganan mingguan • Pembaharuan automatik • Batal bila-bila masa",
				"generic": "Langganan pembaharuan automatik • Batal bila-bila masa"
			},
			"planDuration": {
				"day_one": "{{count}} hari",
				"day_other": "{{count}} hari",
				"week_one": "{{count}} minggu",
				"week_other": "{{count}} minggu",
				"month_one": "{{count}} bulan",
				"month_other": "{{count}} bulan",
				"year_one": "{{count}} tahun",
				"year_other": "{{count}} tahun"
			},
			"recommendedPlan": {
				"plan": "Kami mengesyorkan pelan **{{duration}}** untuk persediaan terbaik bagi peperiksaan anda pada **{{date}}**",
				"subscription": {
					"yearly": "Kami mengesyorkan **langganan tahunan** untuk akses berterusan dan persediaan peperiksaan anda pada **{{date}}**",
					"monthly": "Kami mengesyorkan **langganan bulanan** untuk akses berterusan dan persediaan peperiksaan anda pada **{{date}}**",
					"weekly": "Kami mengesyorkan **langganan mingguan** untuk akses berterusan dan persediaan peperiksaan anda pada **{{date}}**",
					"generic": "Kami mengesyorkan **langganan** untuk akses berterusan dan persediaan peperiksaan anda pada **{{date}}**"
				}
			},
			"disclaimer": "Setelah pembelian disahkan, anda akan diberikan akses penuh kepada kandungan produk ini untuk tempoh yang dipilih. Apabila tempoh ini tamat, anda akan kehilangan akses kepada kandungan terhad. Jika anda ingin melanjutkan akses atas sebarang sebab (contohnya anda menukar tarikh peperiksaan), anda boleh menambah masa melalui pembelian dalam aplikasi tambahan. Untuk maklumat lanjut, sila lihat [Terma Perkhidmatan dan Dasar Privasi](https://memorang.com/legal) kami."
		}
	},
	"progress": {
		"tagProgress": {
			"subtitle": "Berdasarkan {{numItems}} {{item}} yang dijawab merentas {{count}} {{type}}",
			"itemCount": "{{count}} {{item}}",
			"tooltip": "Ini menunjukkan kemajuan anda merentas {{count}} {{type}}. Ia berdasarkan {{itemCount}} {{item}} yang telah anda jawab setakat ini."
		},
		"needsImprovement": {
			"title": "Perlu penambahbaikan",
			"subtitle": "{{type}} yang disyorkan untuk anda perbaiki",
			"cta": "Belajar sekarang"
		},
		"mastery": {
			"high": "Dikuasai",
			"medium": "Hampir dikuasai",
			"low": "Perlu diperbaiki",
			"count": "{{count}} {{item}} dijawab",
			"zeroTooltip": "Belum ada item {{label}} daripada {{total}} item yang dijawab",
			"highTooltip": "Anda telah menguasai {{count}} daripada {{total}} {{item}} yang dijawab",
			"mediumTooltip": "Anda sedang menunjukkan kemajuan pada {{count}} daripada {{total}} {{item}} yang dijawab",
			"lowTooltip": "Anda memerlukan lebih latihan pada {{count}} daripada {{total}} {{item}} yang dijawab"
		},
		"stats": {
			"completion": "Penyiapan",
			"completionCount": "{{completed}}/{{total}} {{item}}",
			"completionTooltip": "Anda telah menyelesaikan {{completed}} daripada {{total}} {{item}}"
		},
		"exams": {
			"title": "Ujian latihan",
			"subtitle_one": "Berdasarkan {{count}} pentaksiran yang selesai",
			"subtitle_other": "Berdasarkan {{count}} pentaksiran yang selesai"
		},
		"summary": {
			"title": "Ringkasan pembelajaran",
			"subtitle": "Berdasarkan {{count}} {{item}} yang dijawab",
			"tooltip": "Ringkasan ini menunjukkan tahap penguasaan dan kemajuan penyiapan anda merentas {{count}} {{item}} kesemuanya. Prestasi anda diukur melalui sesi latihan, pentaksiran dan aktiviti pembelajaran.",
			"mastery": "Penguasaan",
			"quickStats": "Statistik ringkas"
		},
		"languageLearning": {
			"proficiencyCardTitle": "Kecekapan {{skill}}",
			"proficiencyCardTooltip": "Anda kini berada pada tahap {{skill, lowercase}} {{level, lowercase}}",
			"itemTypesCardSubtitle_one": "{{count}} jenis item",
			"itemTypesCardSubtitle_other": "{{count}} jenis item",
			"itemTypesCardTitle": "Item {{skill}}",
			"itemTypeLevelTooltip": "Anda kini berada pada tahap {{skill, lowercase}} {{level, lowercase}} bagi jenis soalan “{{itemType}}”",
			"itemTypesFallbackTitle": "Jenis item",
			"itemTypesEmptyTitle": "Jenis item tidak tersedia",
			"itemTypesEmptySubtitle": "Kami tidak menemui jenis item untuk kemahiran ini. Kembali ke Kemajuan dan cuba lagi.",
			"itemTypesEmptyCta": "Kembali ke kemajuan",
			"notAnswered": "Belum dijawab",
			"answeredSubtitle_one": "Berdasarkan {{count}} item yang dijawab",
			"answeredSubtitle_other": "Berdasarkan {{count}} item yang dijawab",
			"responsesSubtitle_one": "Berdasarkan {{count}} jawapan",
			"responsesSubtitle_other": "Berdasarkan {{count}} jawapan",
			"testsTakenSubtitle_one": "Berdasarkan {{count}} ujian yang diambil",
			"testsTakenSubtitle_other": "Berdasarkan {{count}} ujian yang diambil",
			"startFirstTest": {
				"title": "Mari mulakan",
				"itemsSubtitle_one": "{{count}} item",
				"itemsSubtitle_other": "{{count}} item",
				"guidance": {
					"diagnostic": "Mulakan dengan ujian diagnostik untuk mengenal pasti kekuatan anda dan menyesuaikan pelan belajar.",
					"sectional": "Ujian seksyen menumpukan satu bahagian peperiksaan, jadi anda dapat skor dalam sesi yang lebih singkat.",
					"fullMock": "Ujian olok-olok penuh meniru peperiksaan sebenar dari mula hingga akhir dan memberi skor paling lengkap."
				}
			},
			"noScoresTitle": "Belum ada skor {{skill, lowercase}}",
			"noScoresSubtitle": "Ambil ujian pertama anda untuk melihat anggaran skor dan pecahan tugasan.",
			"noScoresCta": "Mula",
			"noScoresCardSubtitle": "Berdasarkan ujian yang anda ambil",
			"personalBestLabel": "Rekod peribadi anda",
			"latestLabel": "Terkini anda",
			"examCountdown_one": "Peperiksaan anda dalam {{count}} hari",
			"examCountdown_other": "Peperiksaan anda dalam {{count}} hari",
			"greeting": {
				"none": "Jom mulakan, {{firstName}}! 🚀",
				"low": "Permulaan yang baik, {{firstName}} — teruskan! 💪",
				"medium": "Teruskan usaha, {{firstName}}! 💪",
				"high": "Anda hampir sampai, {{firstName}}! 🎯"
			},
			"greetingNoName": {
				"none": "Jom mulakan! 🚀",
				"low": "Permulaan yang baik — teruskan! 💪",
				"medium": "Teruskan usaha! 💪",
				"high": "Anda hampir sampai! 🎯"
			},
			"stats": {
				"untilExam": "Tarikh peperiksaan",
				"itemsAnswered": "Item dijawab",
				"responsesAnswered": "Jawapan"
			}
		}
	},
	"auth": {
		"incorrectPasscode": "Kod laluan salah",
		"incorrectPassword": "Kata laluan salah. Sila cuba lagi.",
		"passwordPlaceholder": "Masukkan kata laluan",
		"emailPlaceholder": "cth., dave@gmail.com",
		"verify": {
			"openEmail": "Buka e-mel untuk meneruskan",
			"signInCta": "Mengesahkan akaun anda...",
			"signUpCta": "Mencipta akaun anda...",
			"contactSupport": "Tidak nampak e-mel itu? Semak folder spam anda atau",
			"contactSupportLink": "Hubungi kami",
			"resendMagicLink": "Hantar semula pautan ajaib",
			"resendMagicLinkIn": "Hantar semula pautan ajaib dalam {{time}}",
			"signInBody": "Anda hampir selesai! Kami sedang mengesahkan butiran anda untuk log masuk dengan selamat ke aplikasi {{appName}}.",
			"signUpBody": "Hampir siap! Kami sedang mengesahkan butiran anda untuk mencipta akaun aplikasi {{appName}} baharu anda.",
			"magicLinkEmail": "Kami telah menghantar pautan ajaib ke **{{email}}**\nKlik pautan dalam e-mel anda untuk log masuk dengan selamat.",
			"magicLinkEmailExpiry": "Pautan ini tamat tempoh dalam 10 minit",
			"confirmEmail": "Sahkan e-mel anda",
			"redirectingToApp": "Mengalihkan ke aplikasi {{appName}}...",
			"appNotOpen": "Aplikasi tidak dibuka? Klik butang di bawah untuk membuka aplikasi berkaitan",
			"openApp": "Buka aplikasi {{appName}}",
			"installAppPrompt": "Jika tiada apa-apa berlaku, pastikan aplikasi {{appName}} telah dipasang pada peranti anda",
			"verifyAccountTitle": "Sahkan akaun anda",
			"emailResent": "Pautan ajaib dihantar ke {{email}}\nSila semak peti masuk anda, termasuk folder spam.",
			"verificationLinkExpired": "Pautan pengesahan telah tamat tempoh",
			"verificationLinkExpiredBody": "Pautan pengesahan tamat tempoh selepas 10 minit dan hanya boleh digunakan sekali. \nAnda boleh meminta pautan baharu dengan log masuk semula",
			"accountSetupTimeoutTitle": "Tidak dapat menyelesaikan log masuk",
			"accountSetupTimeoutBody": "Akaun anda mengambil masa lebih lama daripada jangkaan untuk disediakan. Sila cuba log masuk semula atau hubungi sokongan jika keadaan ini berterusan.",
			"loginAgain": "Log masuk semula",
			"contactSupportExpiredLink": "Jika masalah ini berterusan, beritahu kami",
			"successTitle": "Anda kini telah log masuk dalam tab lain",
			"successBody": "Tutup tab ini atau teruskan dari sini",
			"successCtaLabel": "Teruskan di sini",
			"needHelpLabel": "Perlukan bantuan?",
			"contactSupportButton": "Hubungi kami"
		},
		"contactSupportDialog": {
			"title": "Bermasalah untuk log masuk?",
			"body": "Sila hubungi sokongan pelanggan kami jika anda menghadapi masalah untuk log masuk, atau cuba lagi",
			"cta": "E-mel Kami"
		},
		"emailInstruction": {
			"default": "Jika anda tidak menerima e-mel, semak folder sampah, spam dan baru dipadam",
			"edu": "Jika anda tidak menerima e-mel, semak folder sampah, spam dan baru dipadam, atau hubungi pentadbir IT anda"
		},
		"createSessionLoader": {
			"configuringSession": "Mengkonfigurasi sesi",
			"analyzingMastery": "Menganalisis penguasaan",
			"loadingContent": "Memuatkan kandungan"
		}
	},
	"onboarding": {
		"steps": {
			"profile": {
				"title": "Apakah nama panggilan anda?",
				"description": "Nama pengguna anda dipaparkan pada papan pendahulu awam manakala nama sebenar anda kekal peribadi.",
				"usernameLabel": "Nama pengguna",
				"firstNameLabel": "Nama pertama",
				"lastNameLabel": "Nama akhir",
				"avatarLabel": "Avatar",
				"avatarTooltip": "Avatar dijana secara automatik berdasarkan nama pengguna anda.",
				"profileSaveFailed": "Kami tidak dapat menyimpan profil anda. Sila cuba lagi."
			},
			"testDate": {
				"cta": "Teruskan"
			},
			"examDate": {
				"daysAway": "Itu memberi kita {{value}} hari. Kami akan mengutamakan bidang terlemah anda dengan segera."
			},
			"skills": {
				"chooseAll": "Pilih semua yang berkenaan"
			},
			"plan": {
				"recommended": "Disyorkan"
			},
			"toeicLevelOverview": {
				"title": "Semua orang bermula dari suatu tempat.",
				"description": "Latihan membantu anda menguasai satu tahap sebelum berkembang secara semula jadi ke tahap seterusnya.",
				"illustrationLabel": "Perkembangan daripada Asas (A1–A2) ke Pertengahan (B1–B2) hingga Mahir (C1).",
				"levels": {
					"basic": {
						"name": "Asas",
						"band": "A1–A2"
					},
					"intermediate": {
						"name": "Pertengahan",
						"band": "B1–B2"
					},
					"proficient": {
						"name": "Mahir",
						"band": "C1"
					}
				},
				"progression": {
					"title": "Cara anda akan berkembang",
					"practiceSessions": "Berlatih sesi yang disyorkan",
					"buildMastery": "Bina penguasaan pada tahap semasa anda",
					"growToward": "Terus berkembang ke arah Mahir"
				},
				"levelDetails": {
					"title": "Maksud setiap tahap",
					"scoreRange": "{{band}} · skor {{min}}–{{max}}",
					"basic": {
						"name": "Pengguna Asas",
						"summary": "Bahasa Inggeris mudah di tempat kerja",
						"examples": {
							"forms": "Borang & notis",
							"instructions": "Arahan",
							"announcements": "Pengumuman ringkas"
						}
					},
					"intermediate": {
						"name": "Pengguna Pertengahan",
						"summary": "Komunikasi harian di tempat kerja",
						"examples": {
							"emails": "E-mel & perbualan",
							"customers": "Interaksi dengan pelanggan",
							"followUps": "Susulan mesyuarat"
						}
					},
					"proficient": {
						"name": "Pengguna Mahir",
						"summary": "Bahasa Inggeris profesional & lanjutan",
						"examples": {
							"reports": "Laporan & pembentangan kompleks",
							"negotiations": "Rundingan bernuansa",
							"highStakes": "Konteks profesional berisiko tinggi"
						}
					}
				},
				"disclaimer": "Skor TOEIC Link ialah panduan sejajar CEFR, bukan skor pemisah mutlak. Reading dan Listening berkembang secara berasingan — anda mungkin mencapai tahap berbeza bagi setiap kemahiran."
			},
			"review": {
				"diagnosticChoice": {
					"title": "Diagnostik: {{title}}",
					"body": "{{count}} item untuk mengenal pasti tumpuan anda",
					"duration": "{{minutes}} minit"
				},
				"homeChoice": {
					"title": "Terokai sendiri",
					"body": "Belum bersedia untuk bermula, saya mahu terokai aplikasi dahulu"
				}
			}
		},
		"common": {
			"changeLater": "Anda boleh mengubahnya kemudian"
		},
		"actions": {
			"previous": "Sebelumnya",
			"finish": "Selesai",
			"start": "Mula",
			"continue": "Teruskan",
			"stepIndicator": "Langkah {{step}} daripada {{total}}"
		}
	},
	"more": {
		"profile": {
			"title": "Tentang anda"
		},
		"exam": {
			"title": "Peperiksaan anda"
		},
		"subscriptions": {
			"title": "Produk",
			"redeem": {
				"title": "Tebus pembelian"
			},
			"extend": {
				"cta": "Lanjutkan"
			}
		}
	},
	"examDate": {
		"noticeDialog": {
			"title": "Tetapkan tarikh peperiksaan sasaran anda",
			"description": "Tarikh ini hanya untuk memandu jadual pembelajaran anda dalam aplikasi. Ia tidak menjejaskan pendaftaran peperiksaan rasmi anda.",
			"dismissCta": "Bukan sekarang",
			"confirmCta": "Tetapkan tarikh peperiksaan"
		}
	},
	"account": {
		"title": "Tetapan akaun",
		"currentExam": "Peperiksaan semasa",
		"subscriptions": "Produk",
		"examDate": "Tarikh peperiksaan",
		"examDateUpdated": "Tarikh peperiksaan ditetapkan kepada {{date}}",
		"selectDate": "Pilih tarikh",
		"appearance": "Penampilan",
		"features": "Ciri",
		"audioPlaybackTest": "Tunjukkan dialog ujian main balik audio",
		"theme": "Tema",
		"selectTheme": "Pilih tema",
		"themeOptions": {
			"system": "Sistem",
			"light": "Cerah",
			"dark": "Gelap"
		},
		"accountInfo": "Akaun",
		"username": "Nama pengguna",
		"name": "Nama",
		"nameNotSet": "Belum ditetapkan",
		"save": "Simpan",
		"editUsername": {
			"title": "Edit nama pengguna"
		},
		"editName": {
			"title": "Edit nama"
		},
		"email": "E-mel",
		"dev": "Dev",
		"sandbox": "Sandbox",
		"redoOnboarding": "Ulang pengenalan",
		"about": "Tentang",
		"termsOfService": "Terma perkhidmatan",
		"privacyPolicy": "Dasar privasi",
		"aiToolsTos": "Terma penggunaan alat AI",
		"support": "Sokongan",
		"supportEmailBody": "Saya menghubungi anda kerana saya memerlukan bantuan berkenaan [  ]\n\n\n\nBerikut ialah beberapa maklumat yang boleh membantu menyelesaikannya dengan lebih cepat: \n\nNama pengguna yang dikaitkan dengan akaun (terdapat dalam tetapan apabila log masuk ke aplikasi):\n{{username}}\n\nE-mel yang dikaitkan dengan pesanan saya (terdapat dalam tetapan apabila log masuk ke aplikasi):\n{{email}}\n\nNombor Pesanan (biasanya terdapat dalam e-mel resit yang dihantar selepas pembelian):\n\nAdakah kemungkinan nama atau e-mel berbeza digunakan semasa produk itu dibeli? Jika ya, sila berikan: \n\nNama pertama dan nama akhir:\n\nE-mel:",
		"contactSupport": "Hubungi sokongan",
		"signOut": "Log keluar",
		"signOutConfirmation": "Adakah anda pasti mahu log keluar?",
		"deleteAccount": "Padam akaun",
		"platform": "Platform",
		"partnerships": "Perkongsian",
		"validUntil": "Tamat tempoh pada {{date}}",
		"extendValidity": "Lanjutkan akses",
		"redeemPurchase": "Tebus pembelian",
		"redeemPurchaseNoneFound": "Tiada pembelian untuk ditebus",
		"redeemPurchaseCheckFailed": "Tidak dapat menyemak pembelian. Sila cuba lagi.",
		"purchases": "Pembelian",
		"frequentlyAskedQuestions": "Soalan lazim",
		"deleteFeedbackForm": {
			"placeholder": "Maklum balas"
		}
	},
	"common": {
		"proficiencyLevelUnknown": "Perlu lebih banyak data",
		"proficiencyLevelPendingTooltip": "Jawab lebih banyak item {{label}} untuk menganggarkan tahap anda",
		"on": "pada",
		"gotIt": "Faham",
		"goBack": "Kembali",
		"topic": "topik",
		"itemCount_one": "{{count}} item",
		"itemCount_other": "{{count}} item",
		"examCount_one": "{{count}} peperiksaan",
		"examCount_other": "{{count}} peperiksaan",
		"questionCount_one": "{{count}} soalan",
		"questionCount_other": "{{count}} soalan",
		"item_one": "item",
		"item_other": "item",
		"and": "dan",
		"this": "ini",
		"of": "daripada",
		"knowMore": "Ketahui lagi",
		"proficiency": "kecekapan",
		"didNotAnswer": "Item yang belum anda jawab",
		"notAnswered": "Belum dijawab",
		"attempted": "dicuba",
		"attempt": "percubaan",
		"activity": "aktiviti",
		"performance": "Prestasi",
		"estimatedProficiency": "Anggaran kecekapan",
		"details": "butiran",
		"keepPracticing": "teruskan berlatih!",
		"leaveFeedback": "Beri maklum balas",
		"copiedToClipboard": "Disalin ke papan keratan",
		"eg": "cth.",
		"set": "tetapkan",
		"hint": "pembayang",
		"itemType": "jenis item",
		"minute": "minit",
		"minutes": "{{count}} minit",
		"hour": "jam",
		"hours": "{{count}} jam",
		"continue": "Teruskan",
		"unlock": "Buka",
		"cancel": "Batal",
		"view": "Lihat",
		"switch": "Tukar",
		"update": "Kemas kini",
		"ok": "Ok",
		"yes": "Ya",
		"free": "Percuma",
		"answered": "Dijawab",
		"correct": "Betul",
		"incorrect": "Salah",
		"marked": "Ditanda",
		"unmarked": "Tidak ditanda",
		"skipped": "Dilangkau",
		"skill_one": "kemahiran",
		"skill_other": "kemahiran",
		"word_one": "perkataan",
		"word_other": "perkataan",
		"submitResponse": "Hantar jawapan",
		"viewDetails": "Lihat butiran",
		"sec_one": "saat",
		"sec_other": "saat",
		"point_one": "mata",
		"point_other": "mata",
		"week": "Minggu",
		"month": "Bulan",
		"year": "Tahun",
		"day": "Hari",
		"selectTestDate": "Pilih tarikh peperiksaan",
		"points": "Mata",
		"viewAll": "Lihat semua",
		"timeline": "Garis masa",
		"save": "Simpan",
		"filters": {
			"selectAll": "Pilih semua",
			"deselectAll": "Nyahpilih semua",
			"selectedCount": "{{count}} dipilih",
			"expandSection": "Kembangkan {{section}}",
			"collapseSection": "Runtuhkan {{section}}"
		},
		"showMore": "Tunjukkan lagi",
		"showLess": "Tunjukkan kurang",
		"expandA11yLabel": "Kembangkan penerangan",
		"collapseA11yLabel": "Kuncupkan penerangan",
		"done": "Selesai",
		"clearAll": "Kosongkan semua",
		"clear": "Kosongkan",
		"datePicker": {
			"title": "Pilih tarikh",
			"enterDateLabel": "Masukkan tarikh",
			"enterDateRangeLabel": "Masukkan julat tarikh",
			"dateLabel": "Tarikh",
			"startDateLabel": "Tarikh mula",
			"endDateLabel": "Tarikh tamat",
			"dateRequiredError": "Tarikh diperlukan",
			"invalidDateFormatError": "Format tarikh tidak sah. Sila gunakan MM/DD/YYYY",
			"startAfterEndError": "Tarikh mula tidak boleh selepas tarikh tamat",
			"endBeforeStartError": "Tarikh tamat tidak boleh sebelum tarikh mula",
			"minDateError": "Tarikh mestilah {{date}} atau selepasnya",
			"maxDateError": "Tarikh mestilah {{date}} atau sebelumnya",
			"dateRangeError": "Tarikh mestilah antara {{startDate}} dan {{endDate}}",
			"setDateCta": "Tetapkan tarikh",
			"nextCta": "Seterusnya",
			"setTimeCta": "Tetapkan masa"
		}
	},
	"session": {
		"choicePercentageTooltip": "{{percentage}} pelajar memilih jawapan ini.",
		"choiceCorrectA11yLabel": "Jawapan betul",
		"choiceIncorrectA11yLabel": "Jawapan salah",
		"choiceNotSelectedA11yLabel": "Tidak dipilih",
		"moreItemsAlertDialog": {
			"title": "Item Tambahan",
			"cta": "Faham"
		},
		"results": {
			"followUps": {
				"title": "Susulan"
			},
			"summary": {
				"sessionAnalysis": "Analisis Sesi",
				"itemCount_one": "{{count}} item",
				"itemCount_other": "{{count}} item",
				"skilledItemCount_one": "{{count}} item {{skills}}",
				"skilledItemCount_other": "{{count}} item {{skills}}",
				"levelPhrase_one": "daripada tahap {{levels}}",
				"levelPhrase_other": "daripada tahap {{levels}}",
				"message": "<bold>Syabas!</bold> Anda baru sahaja melengkapkan {{itemPhrase}} dalam {{timeTaken}}.",
				"messageWithLevels": "<bold>Syabas!</bold> Anda baru sahaja melengkapkan {{itemPhrase}} $t(session.results.summary.levelPhrase, {\"count\": {{levelCount}}, \"levels\": \"{{levels}}\"}) dalam {{timeTaken}}.",
				"proficiencyEstimateReady": "Anggaran tahap {{skill}} anda ialah <bold>{{currentLevel}}</bold>. Anda kini bersedia untuk menyasarkan <bold>{{nextLevel}}</bold>.",
				"proficiencyEstimateKeepPracticing": "Anggaran tahap {{skill}} anda ialah <bold>{{currentLevel}}</bold>. Teruskan berlatih sebelum beralih ke <bold>{{nextLevel}}</bold>.",
				"proficiencyEstimateHighest": "Anggaran tahap {{skill}} anda ialah <bold>{{currentLevel}}</bold>. Usaha yang cemerlang!",
				"mixedLevel": "Campuran",
				"overallScore": "Markah Keseluruhan",
				"stats": {
					"itemsAttempted_one": "Item dijawab",
					"itemsAttempted_other": "Item dijawab",
					"pointsEarned_one": "Mata diperoleh",
					"pointsEarned_other": "Mata diperoleh",
					"answeredCorrectly": "Dijawab dengan betul",
					"timeTaken": "Masa diambil",
					"target": "Sasaran",
					"ofTotal": "daripada {{total}}",
					"ofPointsTotal": "daripada {{total}}",
					"skill": "Kemahiran",
					"skills": "Kemahiran",
					"questionType": "Jenis soalan",
					"questionTypes": "Jenis soalan",
					"proficiencyLevel": "Tahap kecekapan",
					"proficiencyLevels": "Tahap kecekapan"
				}
			}
		},
		"prepBanner": {
			"audioStartsIn": "Audio bermula dalam {{seconds}}s",
			"audioStartsInPlayOnce": "Audio bermula dalam {{seconds}}s, dimainkan sekali sahaja",
			"videoStartsIn": "Video bermula dalam {{seconds}}s",
			"videoStartsInPlayOnce": "Video bermula dalam {{seconds}}s, dimainkan sekali sahaja",
			"recordingIn": "Rakaman bermula dalam {{seconds}}s"
		},
		"timeOverrunBanner": {
			"message": "Masa tamat. Dalam peperiksaan sebenar, apa-apa selepas ini tidak akan dimarkahkan. Anda boleh terus berlatih."
		},
		"attributes": {
			"stimulus": "rangsangan"
		},
		"stimulusTypes": {
			"reading": "Membaca",
			"listening": "Mendengar",
			"speaking": "Bertutur",
			"writing": "Menulis",
			"image": "Imej"
		},
		"masteryLevels": {
			"belowBasic": "Bawah Asas",
			"basic": "Asas",
			"belowLowIntermediate": "Bawah Pertengahan Rendah",
			"lowIntermediate": "Pertengahan Rendah",
			"highIntermediate": "Pertengahan Tinggi",
			"advanced": "Lanjutan",
			"proficiencySubtitle": "Pada {{trademark}}, ini bersamaan dengan markah **{{minScore}}-{{maxScore}}/30**",
			"infoSectionLabel": "Maklumat bahagian {{skill}}",
			"infoSectionText": {
				"Reading": "Bahagian Membaca {{trademark}} menilai sejauh mana anda boleh membaca dan memahami bahan bertulis yang digunakan dalam persekitaran akademik. Ia mengandungi dua petikan bacaan, setiap satu kira-kira 700 patah perkataan, dengan 10 soalan bagi setiap petikan. Bahagian Membaca mengambil masa kira-kira 35 minit untuk disiapkan.",
				"Listening": "Bahagian Mendengar {{trademark}} direka untuk mengukur keupayaan anda memahami perbualan dan kuliah dalam bahasa Inggeris. Ia merangkumi kemahiran mendengar untuk: kefahaman asas, memahami sikap dan darjah keyakinan penutur, serta menghubungkan maklumat. Bahagian Mendengar mengambil masa kira-kira 36 minit untuk disiapkan.",
				"Speaking": "Bahagian Bertutur {{trademark}} mengukur keupayaan anda bertutur dalam bahasa Inggeris dengan berkesan dalam suasana akademik. Empat soalan/tugasan tersebut menyerupai situasi sebenar yang mungkin anda hadapi di dalam dan di luar bilik darjah. Bahagian Bertutur mengambil masa kira-kira 16 minit untuk disiapkan.",
				"Writing": "Bahagian Menulis {{trademark}} mengukur keupayaan anda menulis dalam bahasa Inggeris dalam suasana akademik, dan menyampaikan idea anda dengan jelas serta tersusun. Anda akan menaip jawapan pada papan kekunci komputer dan bahagian Menulis mengambil masa kira-kira 29 minit untuk disiapkan."
			}
		},
		"itemTypes": {
			"MCSS": "Aneka pilihan jawapan tunggal",
			"MCSSH": "Aneka pilihan jawapan tunggal dengan sorotan",
			"MCMS": "Aneka pilihan pelbagai jawapan",
			"MCMSH": "Aneka pilihan pelbagai jawapan dengan sorotan",
			"INSERT_TEXT": "Sisip teks",
			"MATCH_MS": "Padanan pelbagai jawapan",
			"MCSSM": "Aneka pilihan jawapan tunggal berpadanan",
			"MCMSM": "Aneka pilihan pelbagai jawapan berpadanan",
			"MCGS": "Aneka pilihan isi tempat kosong",
			"MCOS": "Aneka pilihan susunan tertib",
			"LISTENING_REPLAY": "Main semula rakaman dengar",
			"AUDIO_INPUT": "Input audio",
			"ACADEMIC_DISCUSSION_RESPONSE": "Jawapan perbincangan akademik",
			"INTEGRATED_WRITING_RESPONSE": "Jawapan penulisan bersepadu"
		},
		"passageStem": {
			"itemOfTotal": "Item {{current}} daripada {{total}}",
			"questionOfTotal": "Soalan {{current}} daripada {{total}}",
			"stimulusCorrespondsToNextItems": "Rangsangan berikut berkaitan dengan {{total}} item seterusnya",
			"passage": "Petikan",
			"lecture": "Kuliah",
			"professorsQuestion": "Soalan Profesor",
			"listen": "Dengar",
			"openPassage": "Buka petikan",
			"backToItem": "Kembali ke item",
			"notYetInserted": "Belum disisipkan",
			"insertedAtPosition": "Disisipkan pada kedudukan #{{position}}"
		},
		"hint": {
			"show": "Tunjukkan pembayang"
		},
		"navigation": {
			"next": "Seterusnya",
			"exit": "Keluar",
			"saveAndExit": "Simpan & keluar",
			"previous": "Sebelum",
			"skip": "Langkau",
			"finish": "Selesai",
			"help": "Bantuan",
			"about": "Tip soalan",
			"questionsButtonLabel": "Navigasi soalan",
			"questionsButtonTooltip": "Lompat ke mana-mana soalan atau semak soalan yang ditanda",
			"questionsButtonActiveFiltersA11y": "Penapis aktif: {{count}}",
			"recordingInProgressTooltip": "Anda tidak boleh meninggalkan item ini semasa rakaman sedang berjalan",
			"questionNotReachedTooltip": "Anda belum sampai ke soalan ini"
		},
		"questionTips": {
			"hideFutureLabel": "Jangan tunjukkan tip secara automatik"
		},
		"toolbar": {
			"calculatorTooltip": "Buka kalkulator",
			"highlightTooltip": "Pilih teks untuk menyorot maklumat penting bagi rujukan mudah",
			"markTooltip": "Tandakan soalan ini untuk disemak semula sebelum menghantar",
			"unmarkTooltip": "Klik untuk membuang tanda pada soalan ini"
		},
		"summary": {
			"viewFullInsights": "Lihat cerapan penuh",
			"targetTooltip": "Sasaran prestasi untuk sesi ini."
		},
		"stats": {
			"skill": "Kemahiran",
			"answered": "Dijawab",
			"speed": "Kelajuan",
			"duration": "Tempoh",
			"duration_tooltip": "Tempoh jawapan yang anda rakam: {{duration}} $t(common.sec, {\"count\": {{duration}}})",
			"confidence": "Keyakinan",
			"pointsEarned": "Mata",
			"word": "Perkataan",
			"words": "Perkataan",
			"time_taken": "{{time}} {{sec}}",
			"time_taken_tooltip": "Anda mengambil masa {{time_taken}} $t(common.sec, {\"count\": {{time_taken}}}) untuk membaca dan menjawab item ini",
			"skill_tooltip": "Bidang kemahiran yang dinilai bagi item ini: {{skill}}",
			"answered_correct_tooltip": "Jawapan yang anda hantar adalah betul",
			"answered_incorrect_tooltip": "Jawapan yang anda hantar adalah salah",
			"skipped_tooltip": "Anda tidak menghantar jawapan bagi item ini",
			"words_tooltip": "Bilangan perkataan dalam jawapan bertulis anda: {{count}}",
			"word_tooltip": "Bilangan perkataan dalam jawapan bertulis anda: {{count}}",
			"confidence_tooltip": "Sejauh mana anda yakin semasa menghantar jawapan",
			"points_earned_tooltip_one": "Anda memperoleh {{points}} mata daripada maksimum {{maximumScore}} mata bagi item ini",
			"points_earned_tooltip_other": "Anda memperoleh {{points}} mata daripada maksimum {{maximumScore}} mata bagi item ini",
			"challengers_tooltip": "Bilangan pelajar yang menjawab item ini sebelum anda: {{count}}",
			"learning_mode_points_tooltip": "Mata diperoleh bagi percubaan ini: +{{xp}} XP",
			"pts_earned_tooltip": "Mata diperoleh bagi percubaan ini: {{xp}} XP"
		},
		"breakdownItemTypes": {
			"expandCta": "Kembangkan pecahan"
		},
		"explanation": {
			"title": "Penjelasan",
			"feedback": "Maklum balas",
			"skippedFeedbackNotice": "Anda melangkau soalan ini, jadi maklum balas peribadi tidak dijana."
		},
		"followUps": "Susulan",
		"suggestCorrection": "Cadangkan pembetulan",
		"answer": {
			"correct": "Betul",
			"incorrect": "Salah",
			"skipped": "Dilangkau"
		},
		"confidence": {
			"high": "Tinggi",
			"medium": "Sederhana",
			"low": "Rendah"
		},
		"endDialog": {
			"title": "Tamatkan sesi lebih awal?",
			"confirmEndDiagnostic": "Adakah anda pasti mahu menamatkan sesi anda? Semua kemajuan akan hilang dan anda perlu bermula semula.",
			"confirmEnd": "Anda masih mempunyai {{num}} {{itemLabel}} lagi. Anda boleh tamatkan sekarang atau teruskan belajar untuk menyiapkannya.",
			"confirmEndNoAnswer": "Anda belum menjawab sebarang soalan. Adakah anda pasti mahu tamat sekarang?",
			"confirmEndNoAnswerPositive": "Teruskan belajar",
			"confirmEndNoAnswerNegative": "Tamat sekarang"
		},
		"permissionDialog": {
			"title": "Akses mikrofon diperlukan",
			"descriptionWeb": "Latihan pertuturan menggunakan mikrofon anda. Pelayar anda menyekat akses untuk laman ini — klik ikon kebenaran di sebelah alamat web, benarkan mikrofon, kemudian cuba lagi.",
			"descriptionMobile": "Latihan pertuturan menggunakan mikrofon anda. Benarkan akses mikrofon dalam tetapan peranti anda untuk meneruskan.",
			"promptDescriptionWeb": "Latihan pertuturan menggunakan mikrofon anda. Minta kebenaran dan pilih Benarkan apabila pelayar anda bertanya.",
			"blockedDescriptionWeb": "Akses mikrofon disekat untuk laman ini. Klik ikon di sebelah alamat web, benarkan mikrofon, kemudian minta kebenaran sekali lagi.",
			"ok": "OK",
			"cancel": "Batal",
			"openSettings": "Buka tetapan",
			"requestPermission": "Minta kebenaran",
			"dismissAndExit": "Tutup & keluar",
			"learnMore": "Ketahui lebih lanjut"
		},
		"audioPlaybackTestDialog": {
			"title": "Uji main balik audio",
			"description": "Aplikasi {{appName}} mempunyai pelbagai ciri main balik audio, seperti dalam rangsangan, item ujian dan teks-ke-pertuturan. Untuk memastikan pengalaman terbaik, sila uji audio anda di bawah. Setelah anda sahkan ia berfungsi, teruskan.",
			"troubleshooting": {
				"title": "Menyelesaikan masalah audio",
				"volumeTitle": "Semak kelantangan peranti",
				"volumeDescriptionWeb": "Laraskan kelantangan menggunakan kawalan papan kekunci atau tetapan kelantangan sistem dalam menu/bar tugas",
				"volumeDescriptionMobile": "Gunakan butang kelantangan peranti atau laraskan dalam tetapan sistem",
				"outputTitle": "Sahkan peranti output audio",
				"outputDescription": "Jika menggunakan fon kepala, pastikan ia disambung dengan betul dan dipilih sebagai peranti output aktif",
				"browserTitle": "Semak audio tab pelayar",
				"browserDescription": "Cari ikon pembesar suara yang disenyapkan di sebelah tajuk tab dan nyahsenyapkannya jika ada."
			},
			"skipCheck": "Langkau semakan ini pada kali seterusnya",
			"workingButton": "Sahkan audio",
			"textToHear": "Anda sepatutnya mendengar: {{text}}"
		},
		"overall": "Keseluruhan",
		"subskills": {
			"content": {
				"title": "Kandungan"
			},
			"languageUse": {
				"title": "Penggunaan Bahasa"
			},
			"organizationAndDevelopment": {
				"title": "Organisasi dan Perkembangan"
			},
			"topicDevelopment": {
				"title": "Perkembangan Topik"
			},
			"delivery": {
				"title": "Penyampaian"
			}
		},
		"finalizing": {
			"title": "Memuktamadkan keputusan anda",
			"gradingProgress": "Menilai jawapan..."
		}
	},
	"questionTypes": {
		"descriptions": {
			"Repeat Sentence": "Tugasan pertuturan di mana pelajar mengulang ayat yang didengar setepat mungkin.",
			"Read Aloud": "Soalan pertuturan di mana pelajar membaca petikan dengan kuat untuk dinilai.",
			"Describe Image": "Tugasan pertuturan di mana pelajar menerangkan bahan visual secara terperinci.",
			"Write Essay": "Tugasan jawapan bertulis yang memerlukan esei berstruktur tentang tajuk yang diberikan.",
			"Retell Lecture": "Tugasan pertuturan di mana pelajar merumuskan kuliah atau ceramah yang didengar.",
			"Summarize Group Discussion": "Tugasan mendengar di mana pelajar merumuskan perbincangan berbilang penutur.",
			"Answer Short Question": "Tugasan pertuturan ringkas menjawab satu soalan pendek dengan jawapan padat.",
			"Respond to a Situation": "Tugasan pertuturan di mana pelajar memberi respons yang sesuai kepada situasi yang diterangkan.",
			"Summarize Written Text": "Tugasan membaca di mana pelajar merumuskan petikan dengan perkataan sendiri.",
			"Reorder Paragraph": "Tugasan membaca di mana pelajar menyusun perenggan yang bercelaru mengikut urutan yang betul.",
			"Fill in the Blanks (Dropdown)": "Tugasan membaca di mana setiap tempat kosong diisi daripada senarai juntai bawah pilihan.",
			"Fill in the Blanks (Type In)": "Tugasan mendengar di mana pelajar menaip perkataan atau frasa pendek yang hilang.",
			"Fill in the Blanks (Drag and Drop)": "Tugasan membaca di mana perkataan yang hilang diisi dengan menyeret pilihan ke tempat kosong.",
			"Multiple Choice, Single Answer": "Soalan aneka pilihan di mana pelajar memilih satu jawapan yang betul.",
			"Multiple Choice, Single Answer (Reading)": "Soalan aneka pilihan membaca di mana pelajar memilih satu jawapan yang betul.",
			"Multiple Choice, Single Answer (Listening)": "Soalan aneka pilihan mendengar di mana pelajar memilih satu jawapan yang betul.",
			"Multiple Choice, Multiple Answers": "Soalan di mana pelajar boleh memilih lebih daripada satu jawapan yang betul.",
			"Multiple Choice, Multiple Answers (Reading)": "Soalan membaca di mana pelajar boleh memilih lebih daripada satu jawapan yang betul.",
			"Multiple Choice, Multiple Answers (Listening)": "Soalan mendengar di mana pelajar boleh memilih lebih daripada satu jawapan yang betul.",
			"Summarize Spoken Text": "Tugasan mendengar di mana pelajar menulis rumusan tentang apa yang didengar.",
			"Highlight Correct Summary": "Tugasan mendengar di mana pelajar menandakan rumusan yang paling sepadan dengan audio.",
			"Select Missing Word": "Tugasan mendengar berbentuk isi tempat kosong di mana pelajar memilih perkataan yang hilang.",
			"Highlight Incorrect Words": "Tugasan mendengar di mana pelajar menandakan perkataan dalam transkrip yang berbeza daripada audio.",
			"Write from Dictation": "Tugasan mendengar di mana pelajar menulis semula ayat yang didengar."
		}
	},
	"report": {
		"readFullInsights": "Baca cerapan penuh",
		"productName": "{{examName}} {{type}}",
		"startedAt": "Bermula pada {{time}}",
		"itemTypesTitle": "Pecahan jenis item",
		"itemTypesFilterAll": "Semua",
		"questionTypeCardTitle": "Pecahan jenis item {{skill}}",
		"questionTypeCardSubtitle_one": "Berdasarkan {{count}} jenis item {{skill}} dalam sesi ini",
		"questionTypeCardSubtitle_other": "Berdasarkan {{count}} jenis item {{skill}} dalam sesi ini",
		"questionTypeCardAltSubtitle_one": "Berdasarkan {{count}} jenis item dalam sesi ini",
		"questionTypeCardAltSubtitle_other": "Berdasarkan {{count}} jenis item dalam sesi ini",
		"questionTypeRowSubtitle_zero": "Tiada item dijawab",
		"questionTypeRowSubtitle_one": "{{count}} item dijawab",
		"questionTypeRowSubtitle_other": "{{count}} item dijawab",
		"itemTypeDetail": {
			"review_one": "Semak item",
			"review_other": "Semak item",
			"stats": {
				"answered_one": "Item dijawab",
				"answered_other": "Item dijawab",
				"avgTime": "Purata masa setiap item"
			}
		},
		"reviewAnswersDialog": {
			"title": "Semak Jawapan",
			"sections": {
				"skills": "Kemahiran",
				"questionTypes": "Jenis soalan",
				"proficiency": "Kecekapan",
				"performance": "Prestasi"
			},
			"summaryNone": "Pilih penapis yang mempunyai item untuk meneruskan.",
			"summaryAll_one": "Semak kesemua {{count}} jawapan.",
			"summaryAll_other": "Semak kesemua {{count}} jawapan.",
			"summaryFiltered_one": "Semak {{count}} jawapan yang sepadan dengan {{filters}}.",
			"summaryFiltered_other": "Semak {{count}} jawapan yang sepadan dengan {{filters}}.",
			"reviewAnswers_one": "Semak {{count}} jawapan",
			"reviewAnswers_other": "Semak {{count}} jawapan",
			"more": "{{count}} lagi"
		},
		"itemDetail": {
			"title": "Semak jawapan saya",
			"filterAll": "Semua",
			"filterCorrect": "Betul",
			"filterIncorrect": "Salah",
			"filterMarked": "Ditanda",
			"emptyTitle": "Tiada item yang sepadan",
			"emptyDescription": "Tiada item sesi anda yang sepadan dengan penapis yang dipilih ({{filter}}). Cuba laraskan atau kosongkan penapis untuk melihat lebih banyak keputusan.",
			"emptyCta": "Kosongkan penapis"
		},
		"answerCardTitle": "Item dijawab",
		"answerCardSubtitle_one": "Lihat pencapaian anda merentas semua soalan",
		"answerCardSubtitle_other": "Lihat pencapaian anda merentas kesemua {{count}} soalan",
		"skillsBreakdown": {
			"title": "Pecahan Kemahiran",
			"subtitle_one": "Berdasarkan {{count}} item",
			"subtitle_other": "Berdasarkan {{count}} item"
		},
		"studyPack": "Pakej Pembelajaran",
		"practiceTestCompleted": "Ujian latihan selesai",
		"studySessionCompleted": "Sesi pembelajaran selesai",
		"diagnosticSessionCompleted": "Sesi diagnostik selesai",
		"timeElapsed": "Masa berlalu",
		"stats": {
			"answered": "DIJAWAB",
			"time elapsed": "MASA BERLALU",
			"avg speed": "PURATA KELAJUAN",
			"hints used": "PEMBAYANG DIGUNAKAN"
		},
		"pointsInfo": {
			"feedbackText": {
				"advanced": "Hebat sekali—teruskan mengejar kecemerlangan!",
				"highIntermediate": "Anda melakukannya dengan baik—teruskan mengasah kekuatan anda!",
				"lowIntermediate": "Kemajuan anda mantap—teruskan!",
				"basic": "Teruskan berusaha untuk meningkatkan kebolehan anda!"
			},
			"infoText": "Anda telah menyelesaikan **{{numActivities}} {{activityLabel}}** untuk melatih {{skillsText}} {{skills}} anda. {{skillDetails}}. Secara keseluruhan, anda memperoleh **{{numPointsEarned}} daripada {{numTotalPoints}} mata**, menunjukkan kecekapan **{{compositeLevel}}** merentas {{thisText}} {{skills}}. {{compositeFeedback}}",
			"infoText.singleSkill": "Anda telah menyelesaikan **{{itemCount}} {{itemLabel}}** yang menumpukan pada kemahiran **{{skill_1}}** anda. Anda memperoleh **{{skill_1_score}} daripada {{skill_1_total}}**, menunjukkan kecekapan **{{proficiency}}**. {{compositeFeedback}}",
			"infoText.multiSkill": "Anda telah menyelesaikan **{{itemCount}} {{itemLabel}}**, melatih kemahiran **{{skills_text}}** anda. {{skill_details}} Secara keseluruhan, anda memperoleh **{{overall_score}} daripada {{overall_total}} mata**, menunjukkan kecekapan **{{overall_proficiency}}** merentas kemahiran ini. {{compositeFeedback}}",
			"skillDetails": "Dalam **{{skill}}**, anda memperoleh **{{score}} daripada {{total}}**, menunjukkan kecekapan **{{proficiency}}**."
		},
		"actions": {
			"goToHome": "Pergi ke laman utama",
			"studyMore": "Belajar lagi",
			"studyFree": "Belajar {{tagTypes}} percuma",
			"reviewAnswers": "Semak jawapan"
		},
		"nextAction": {
			"title": "Disyorkan: latihan {{focus}}",
			"dialog": {
				"title": "Sesi pembelajaran yang disyorkan",
				"subtitle": "Fokus pada bidang yang perlu diperbaiki"
			},
			"fallback": {
				"title": "Teruskan latihan",
				"description": "Bina sesi pembelajaran berdasarkan bidang yang ingin anda pelajari seterusnya."
			}
		},
		"premium": {
			"upgradeCta": "Naik taraf ke premium"
		},
		"disclaimer": {
			"title": "Penafian",
			"summativeBody": "Markah ujian latihan hanyalah anggaran dan tidak menjamin keputusan yang sama dalam ujian {{examName}} sebenar."
		},
		"performance": {
			"title": "Prestasi",
			"subtitle": "Berdasarkan {{count}} item",
			"correct": "Betul",
			"correctItems": "{{count}} item",
			"incorrect": "Salah",
			"incorrectItems": "{{count}} item"
		},
		"mastery": {
			"performanceTitle": "Prestasi",
			"sessionMasteryTitle": "Anggaran kecekapan",
			"subtitle_assessment": "Berdasarkan kesemua {{count}} {{item}} daripada pentaksiran ini",
			"subtitle_session": "Berdasarkan kesemua {{count}} {{item}} daripada sesi ini"
		},
		"sessionAnalysis": {
			"title": "Analisis sesi",
			"subtitle": "Analisis dan saranan peribadi",
			"viewFullAnalysis": "Lihat analisis",
			"feedbackDialog": {
				"body": "Kami mengeluarkan kemas kini hampir setiap hari dan komited untuk memperbaiki. Sudikah anda memberikan maklum balas?",
				"placeholder": "Masukkan maklum balas anda di sini",
				"cta": "Hantar maklum balas",
				"successMessage": "Maklum balas dihantar. Terima kasih!",
				"feedbackLimitError": "Maklum balas mestilah sekurang-kurangnya 10 aksara"
			},
			"menuActions": {
				"copy": "Salin",
				"altCopy": "Salin teks ringkasan",
				"altPositiveFeedback": "Ini membantu",
				"positiveFeedback": "Jawapan yang baik",
				"negativeFeedback": "Jawapan yang kurang baik",
				"reportIssue": "Lapor",
				"altReportIssue": "Laporkan jawapan ini",
				"emailSummary": "E-mel teks ringkasan",
				"emailAlreadySent": "E-mel telah dihantar",
				"copiedAnalysis": "Analisis disalin ke papan keratan",
				"emailSent": "E-mel dihantar ke {{email}}. Jika anda tidak menerima e-mel, semak folder sampah, spam dan baru dipadam",
				"emailFailed": "Gagal menghantar e-mel ke {{email}}",
				"emailInstructionMessage": "Jika anda tidak menerima e-mel, semak folder sampah, spam dan baru dipadam, atau hubungi pentadbir IT anda"
			}
		}
	},
	"feedback": {
		"successMessage": "Maklum balas dihantar. Terima kasih!"
	},
	"dialog": {
		"feedback": {
			"defaultFeedbackBody": "Apa yang anda suka? Apa yang boleh diperbaiki? Kami menambah baik platform ini setiap hari dan pasukan kami membaca setiap maklum balas. Terima kasih!",
			"title": "Kongsi maklum balas anda",
			"body": "Apa yang anda suka? Apa yang boleh diperbaiki? Kami menambah baik platform ini setiap hari dan pasukan kami membaca setiap maklum balas. **Terima kasih!**",
			"positiveBody": "Kami gembira ini membantu! Beritahu kami **apa yang anda suka.**",
			"negativeBody": "Bantu kami memahami apa yang tidak kena supaya kami boleh **menambah baik jawapan kami.**",
			"placeholder": "Masukkan maklum balas",
			"cta": "Hantar maklum balas"
		},
		"report": {
			"title": "Hantar laporan",
			"body": "Bantu kami memahami apa yang tidak kena dengan jawapan ini",
			"cta": "Hantar laporan"
		},
		"suggestCorrection": {
			"title": "Cadangkan pembetulan",
			"body": "Bantu kami meningkatkan ketepatan kandungan ini dengan **melaporkan sebarang kesilapan.**",
			"cta": "Hantar"
		},
		"feedbackReasons": {
			"negative": {
				"inaccurate": {
					"title": "Tidak tepat",
					"description": "Jawapan mengandungi maklumat yang salah"
				},
				"notHelpful": {
					"title": "Tidak membantu",
					"description": "Jawapan tidak menjawab soalan saya"
				},
				"incomplete": {
					"title": "Tidak lengkap",
					"description": "Jawapan tidak mempunyai butiran penting"
				},
				"hardToUnderstand": {
					"title": "Sukar difahami",
					"description": "Jawapan mengelirukan atau tidak jelas"
				},
				"other": {
					"title": "Lain-lain",
					"description": "Sesuatu yang lain"
				}
			},
			"report": {
				"misinformation": {
					"title": "Maklumat palsu",
					"description": "Jawapan mengandungi maklumat palsu atau mengelirukan"
				},
				"harmfulContent": {
					"title": "Kandungan Berbahaya atau Menyinggung",
					"description": "Ucapan kebencian, gangguan atau bahasa tidak sesuai"
				},
				"violatesPolicies": {
					"title": "Melanggar Dasar",
					"description": "Spam, promosi diri atau kandungan menyalahi undang-undang"
				},
				"other": {
					"title": "Lain-lain",
					"description": "Nyatakan apa yang tidak kena dalam ayat anda sendiri"
				}
			}
		},
		"faqs": {
			"title": "Soalan lazim",
			"body": "Berikut ialah beberapa soalan yang paling kerap ditanya tentang aplikasi ini. Jika anda mempunyai sebarang soalan lain, sila hubungi kami di support@memorang.ai"
		},
		"delete": {
			"title": "Padam akaun",
			"body": "Kami sedih melihat anda pergi dan mendoakan yang terbaik untuk perjalanan akademik dan profesional anda!",
			"options": "Terlalu mahal|Saya sudah menduduki peperiksaan|Saya tidak suka kandungannya|Ciri/fungsi tidak mencukupi|Lain-lain",
			"confirmdelete": {
				"title": "Sahkan Pemadaman Akaun",
				"cta": "Padam",
				"errorMessage": "Maaf, e-mel itu tidak sepadan dengan akaun ini. Sila cuba lagi",
				"successMessage": "Akaun berjaya dipadam!",
				"validEmail": "Sila masukkan alamat e-mel yang sah"
			}
		}
	},
	"recorder": {
		"tapToRecord": "Ketik untuk merakam jawapan anda",
		"responseAudioUnavailable": "Audio jawapan tidak tersedia untuk dimainkan",
		"recording": "Merakam",
		"recordingCompleted": "Rakaman Selesai",
		"getReady": "Bersedia",
		"timeIsUp": "Masa tamat. Jawapan anda tidak dirakam.",
		"alert": {
			"title": "Tempoh maksimum dicapai",
			"body": "Rakaman telah dihentikan kerana mencapai tempoh maksimum {{maxDuration}} saat."
		},
		"uiElementPressed": "Rakaman dihentikan - rangsangan dibuka semasa rakaman sedang berjalan."
	},
	"writing": {
		"placeholder": "Tulis jawapan anda di sini...",
		"wordCount": "{{count}} {{word}}",
		"title": "Jawapan anda",
		"submit": "Hantar",
		"helper": {
			"range": "Tulis {{min}}–{{max}} patah perkataan untuk menghantar jawapan anda",
			"min": "Tulis sekurang-kurangnya {{min}} patah perkataan untuk menghantar jawapan anda",
			"max": "Pendekkan jawapan anda kepada {{max}} patah perkataan atau kurang"
		}
	},
	"navbar": {
		"home": "Utama",
		"progress": "Kemajuan",
		"insights": "Cerapan",
		"leaderboard": "Pendahulu",
		"store": "Kedai",
		"more": "Lagi",
		"redeem": "Tebus",
		"study-pack": "Pakej Pembelajaran",
		"podcasts": "Podcast",
		"modules": "Modul",
		"account": "Tetapan akaun",
		"accountTab": "Akaun",
		"privacy": "Privasi",
		"terms": "Terma",
		"cme": "CME"
	},
	"redeem": {
		"contactSupportHint": "Sudah memasukkan kod dengan betul tetapi masih bermasalah? **Hubungi sokongan** dan pastikan anda menyertakan kod akses serta butiran pembelian anda",
		"olxDialog": {
			"unlockedTitle": "Akses Dibuka Kunci",
			"expiredTitle": "Akses Tamat Tempoh",
			"testInfo": "**Peperiksaan:** {{examName}} | **Ujian:** {{bundleName}}",
			"upcomingBody_one": "Akses anda kepada ujian OLX telah dibuka kunci!\n\nAnda boleh memulakan sesi anda dalam **{{count}} hari**. Sila semak semula kemudian untuk memulakan sesi anda daripada tab Ujian Latihan.",
			"upcomingBody_other": "Akses anda kepada ujian OLX telah dibuka kunci!\n\nAnda boleh memulakan sesi anda dalam **{{count}} hari**. Sila semak semula kemudian untuk memulakan sesi anda daripada tab Ujian Latihan.",
			"activeBody": "Akses anda kepada ujian OLX kini aktif!\n\nAnda boleh memulakan sesi anda pada bila-bila masa sebelum **{{date}}**.\n\nAdakah anda ingin memulakan sesi sekarang atau kemudian?",
			"expiredBody": "Akses anda kepada ujian OLX telah tamat tempoh pada **{{date}}**.\n\nSila hubungi profesor atau pentadbir sekolah anda untuk bantuan lanjut.",
			"startNowCta": "Mula Sekarang",
			"startLaterCta": "Mula Kemudian"
		},
		"unexpectedError": "Ralat yang tidak dijangka telah berlaku."
	},
	"redeemCode": {
		"titleRedeem": "Tebus Akses",
		"titleGranted": "Akses Diberikan",
		"formTitle": "Masukkan kod akses anda",
		"accessCodeHint": "Jika anda mempunyai kod akses, sila masukkannya di sini, termasuk tanda sempang.",
		"submit": "Tebus",
		"access": "Akses di sini",
		"helpFindCode": "Perlukan bantuan mencari kod anda?",
		"troubleRedeeming": "Menghadapi masalah menebus? Tanya Pembantu!",
		"skipStep": "Langkau langkah ini"
	},
	"autoRedeem": {
		"redeem": "Tebus",
		"redeeming": "Menebus...",
		"continue": "Teruskan",
		"unredeemedPrompt_one": "Terdapat **{{count}} produk** yang dikaitkan dengan alamat e-mel **{{email}}** yang belum ditebus. Adakah anda mahu menambahkannya ke akaun anda?",
		"unredeemedPrompt_other": "Terdapat **{{count}} produk** yang dikaitkan dengan alamat e-mel **{{email}}** yang belum ditebus. Adakah anda mahu menambahkannya ke akaun anda?",
		"successMessage_one": "Tahniah! **Produk** di bawah telah dibuka pada akaun anda. Selepas menekan teruskan, konteks aplikasi anda akan ditukar untuk mencerminkan peperiksaan: **{{examName}}**. Anda boleh mengubahnya pada bila-bila masa dalam tetapan akaun jika anda mahu belajar untuk peperiksaan lain atau membeli produk lain.",
		"successMessage_other": "Tahniah! **{{count}} produk** di bawah telah dibuka pada akaun anda. Selepas menekan teruskan, konteks aplikasi anda akan ditukar untuk mencerminkan peperiksaan: **{{examName}}**. Anda boleh mengubahnya pada bila-bila masa dalam tetapan akaun jika anda mahu belajar untuk peperiksaan lain atau membeli produk lain."
	},
	"olxEligibility": {
		"goToPracticeTests": "Pergi ke Ujian latihan"
	},
	"moreChallenges": {
		"challenges": "Cabaran",
		"challengesCount": "{{value}} Cabaran"
	},
	"tts": {
		"tooltip": "Dengar"
	},
	"commandBar": {
		"placeholder": "Cari...",
		"input": {
			"placeholder": "Taip arahan atau cari"
		},
		"sections": {
			"quickActions": "Tindakan pantas"
		},
		"actions": {
			"changeExam": "Tukar peperiksaan",
			"switchToDarkMode": "Tukar ke mod gelap",
			"switchToLightMode": "Tukar ke mod cerah",
			"setExamDate": "Tetapkan tarikh peperiksaan"
		}
	},
	"filterView": {
		"placeholder": "Cari peperiksaan..."
	},
	"transcript": {
		"show": "Tunjukkan transkrip",
		"hide": "Sembunyikan transkrip"
	},
	"testDriver": {
		"appBar": {
			"logoAlt": "Logo Aplikasi",
			"testNameLabel": "Nama Ujian",
			"sectionLabel": "Bahagian",
			"back": "Kembali",
			"pause": "Jeda",
			"menuLabel": "Lagi pilihan"
		},
		"pteSummativeAppbar": {
			"progressBarLabel": "Kemajuan ujian",
			"of": "daripada",
			"pauseSession": "Jeda Sesi",
			"timerTooltip": {
				"item": "Baki masa untuk soalan ini",
				"section": "Baki masa dalam bahagian ini",
				"test": "Baki masa dalam ujian ini"
			}
		},
		"pteSummativeBottomAppbar": {
			"next": "Seterusnya"
		},
		"progressBar": {
			"timeLeftLabel": "Baki masa untuk soalan ini",
			"timeLeftForUnit": "Baki masa untuk unit ini",
			"questionOf": "Soalan {{current}} daripada {{total}}",
			"questionProgress": "<b>{{current}}</b> daripada {{total}}",
			"timesUp": "Masa tamat",
			"statusTooltips": {
				"answered": "Dijawab",
				"inProgress": "Sedang Dijawab",
				"skipped": "Dilangkau",
				"notSeen": "Belum Dilihat"
			}
		},
		"timeRemainingDialog": {
			"title": "Anda masih ada masa",
			"body": "Masih ada baki masa untuk unit ini. Adakah anda mahu menyemak jawapan anda sebelum menghantar?",
			"reviewCta": "Semak jawapan saya"
		},
		"itemTypes": {
			"reorderParagraph": {
				"sourceTitle": "Sumber",
				"answerTitle": "Jawapan Anda",
				"remainingBadge": "{{count}} berbaki",
				"placedBadge": "{{count}} diletakkan",
				"pointsBadge": "{{earned}}/{{max}} mata",
				"emptyHint": "Seret perenggan ke sini dari panel kiri"
			}
		}
	},
	"redeemCopilot": {
		"contactSupport": {
			"title": "Maklumat Sokongan",
			"emailLabel": "E-mel",
			"subjectLabel": "Subjek",
			"messageBodyLabel": "Kandungan Mesej",
			"appDetailsLabel": "Butiran Aplikasi",
			"appNameLabel": "Nama",
			"versionLabel": "Versi",
			"platformLabel": "Platform"
		},
		"chat": {
			"assistantTitle": "Pembantu Sokongan {{tenantName}}",
			"fallbackTitle": "Sembang",
			"betaWarning": "Pembantu AI ini berada dalam **Beta**—respons mungkin kadangkala tidak tepat atau tidak lengkap.",
			"greeting": "Hai 👋 Menghadapi masalah untuk mendapatkan akses kepada produk? Saya di sini untuk membantu! Mari kita kenal pasti masalah tersebut dahulu. Yang manakah antara berikut paling menggambarkan situasi anda?\n\n1. Saya mempunyai kod akses, tetapi ia tidak berfungsi.\n2. Saya telah membuat pembelian, tetapi tidak dapat mencari kod akses saya.\n3. Saya sepatutnya diberi akses melalui sekolah saya, tetapi tidak dapat mencari kod akses saya.\n4. Saya pernah mempunyai akses kepada produk sebelum ini, tetapi kini tidak dapat mengaksesnya.\n\nSila masukkan nombor yang berkaitan dengan isu anda.",
			"input": {
				"label": "Taip mesej...",
				"sendLabel": "Hantar"
			}
		},
		"accessContent": {
			"redeemedTitle": "🎉 Berjaya Ditebus",
			"previouslyRedeemedTitle": "🚀 Pernah Ditebus",
			"subtitle": "Akses kandungan anda di sini",
			"expires": "Tamat tempoh: {{date}}",
			"openCta": "Buka"
		},
		"purchases": {
			"title": "🎉 Kod Akses Ditemui",
			"subtitle": "Tebus untuk mendapatkan akses kepada kandungan anda",
			"accessCodesLabel_one": "Kod Akses",
			"accessCodesLabel_other": "Kod Akses",
			"moreCodes_one": "(+ {{count}} lagi)",
			"moreCodes_other": "(+ {{count}} lagi)",
			"featuresLabel": "Ciri-ciri",
			"redeemCta": "Tebus"
		}
	},
	"versionChecker": {
		"banner": {
			"message": "Versi baharu tersedia, klik muat semula untuk mengemas kini.",
			"refreshCta": "Muat semula",
			"refreshA11yLabel": "Muat semula untuk mengemas kini aplikasi",
			"dismissTooltip": "Tutup",
			"dismissA11yLabel": "Tutup pemberitahuan kemas kini"
		}
	},
	"cme": {
		"type": "Jenis CME",
		"chooseExportMethod": "Pilih kaedah ekspor",
		"selectDateRange": "Pilih julat tarikh",
		"from": "Dari",
		"to": "Hingga",
		"sendPdfTo": "Hantar PDF ke {{email}}",
		"downloadCertificate": "Muat Turun Sijil ke PDF",
		"amaCategory1": "AMA PRA Category 1",
		"creditEarnedSubtitle": "Kredit CME yang Diperoleh",
		"confirmYourName": "Sahkan nama Anda",
		"certificateNameNotice": "Nama ini akan dicetak pada Sijil CME Anda.",
		"firstName": "Nama pertama",
		"lastName": "Nama akhir",
		"firstNamePlaceholder": "Masukkan nama pertama Anda",
		"lastNamePlaceholder": "Masukkan nama akhir Anda",
		"confirm": "Sahkan",
		"creditsEarnedTitle": "CME yang Diperoleh",
		"creditRatioCaption": "12 Cabaran = 1 Kredit CME",
		"earned": "Diperoleh",
		"available": "Tersedia",
		"creditsValue": "{{count}} CME",
		"exportCertificate": "Eksport Sijil CME",
		"exportDisabledCaption": "Anda perlu memperoleh sekurang-kurangnya 1 kredit CME untuk mengeksport sijil Anda",
		"viewDisclaimer": "Lihat penafian CME"
	}
}
